/**
 * Desktop mega menu: open on hover, follow the parent link on click.
 * Loaded with defer so it does not block parsing of the hero / LCP image.
 */
(function () {
  var CORRIDOR_PAD = 48;
  var mq = window.matchMedia('(max-width: 989px)');
  var listenersBound = false;

  function pointInRect(x, y, rect, pad) {
    return (
      x >= rect.left - pad &&
      x <= rect.right + pad &&
      y >= rect.top - pad &&
      y <= rect.bottom + pad
    );
  }

  function bindMenu(details) {
    if (details._hahMegaAbort) details._hahMegaAbort.abort();

    var ac = new AbortController();
    details._hahMegaAbort = ac;
    var opts = { signal: ac.signal };

    var summary = details.querySelector('summary');
    var content = details.querySelector('.mega-menu__content');
    var trigger = details.querySelector('.header__menu-item-icon, .mega-menu__trigger, .header__menu-toggle');

    if (!summary || !content) return;

    function hydratePanel() {
      var tpl = content.firstElementChild;
      if (!tpl || tpl.tagName !== 'TEMPLATE') return;
      content.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      content.removeAttribute('data-mega-lazy');
    }

    function setExpanded(open) {
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeMenu() {
      details.removeAttribute('open');
      setExpanded(false);
      if (details._hahPointerMove) {
        document.removeEventListener('mousemove', details._hahPointerMove);
        details._hahPointerMove = null;
      }
    }

    details._hahCloseMega = closeMenu;

    function closeOthers() {
      document.querySelectorAll('details.mega-menu[open]').forEach(function (other) {
        if (other === details) return;
        if (typeof other._hahCloseMega === 'function') {
          other._hahCloseMega();
        } else {
          other.removeAttribute('open');
        }
      });
    }

    if (mq.matches) {
      if (!trigger) return;
      trigger.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (details.hasAttribute('open')) {
            closeMenu();
          } else {
            hydratePanel();
            closeOthers();
            details.setAttribute('open', '');
            setExpanded(true);
          }
        },
        opts
      );
      return;
    }

    function inSafeArea(x, y) {
      var triggerRect = summary.getBoundingClientRect();
      var panelRect = content.getBoundingClientRect();
      if (pointInRect(x, y, triggerRect, 6)) return true;
      if (pointInRect(x, y, panelRect, 6)) return true;
      if (
        y >= triggerRect.bottom - 6 &&
        y <= panelRect.top + 6 &&
        x >= triggerRect.left - CORRIDOR_PAD &&
        x <= triggerRect.right + CORRIDOR_PAD
      ) {
        return true;
      }
      return false;
    }

    function onPointerMove(event) {
      if (!inSafeArea(event.clientX, event.clientY)) closeMenu();
    }

    function openMenu() {
      hydratePanel();
      closeOthers();
      details.setAttribute('open', '');
      setExpanded(true);
      details._hahPointerMove = onPointerMove;
      document.addEventListener('mousemove', onPointerMove);
    }

    summary.addEventListener('mouseenter', openMenu, opts);
    summary.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        if (summary.dataset.navHref) window.location.href = summary.dataset.navHref;
      },
      opts
    );
  }

  function hydrateAll() {
    document.querySelectorAll('details.mega-menu .mega-menu__content > template').forEach(function (tpl) {
      var content = tpl.parentNode;
      if (!content) return;
      content.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      content.removeAttribute('data-mega-lazy');
    });
  }

  function init() {
    document.querySelectorAll('details.mega-menu').forEach(bindMenu);
  }

  function bindSharedListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('click', function (event) {
      if (event.target.closest('.mega-menu')) return;
      document.querySelectorAll('details.mega-menu[open]').forEach(function (menu) {
        if (typeof menu._hahCloseMega === 'function') {
          menu._hahCloseMega();
        } else {
          menu.removeAttribute('open');
        }
      });
    });

    var onBreakpoint = function () {
      init();
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpoint);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onBreakpoint);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector && event.target.querySelector('details.mega-menu')) {
        init();
      }
    });
  }

  bindSharedListeners();
  init();

  function scheduleIdleHydrate() {
    var run = function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(hydrateAll, { timeout: 2500 });
      } else {
        setTimeout(hydrateAll, 1);
      }
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }
  scheduleIdleHydrate();
})();
